import { createSelector } from '@reduxjs/toolkit';

import { StoreState } from '../types';

import { UserState } from './types';

export const getUserState = (state: StoreState): UserState => state.user;

export const getUserPermissions = createSelector(
  getUserState,
  permissions => permissions.data,
);

export const getEmployeeNumber = createSelector(
  getUserPermissions,
  data => data?.employeeNumber,
);
